// filepath: apps/web/src/features/admin/effectsMetrics/errorMessage.ts
//
// FR-UI-ADM-9 — classify fetch errors into the i18n keys used
// by the page + dialog surfaces. Mirrors hmacKeys/errorMessage.ts.

import type { EffectsMetricsFetchErrorKind } from "./types";

/**
 * classifyEffectsMetricsError maps an HTTP status / error
 * condition to the i18n key consumed by the 5-state error
 * component (FR-UI-CORE-10).
 */
export function classifyEffectsMetricsError(
  status: number,
  body: unknown,
): EffectsMetricsFetchErrorKind {
  if (status === 401) return "error_unauthorized";
  if (status === 504) return "error_upstream_timeout";
  if (status >= 500) return "error_upstream_unreachable";
  if (status === 400 && typeof body === "object" && body !== null) {
    const err = (body as { error?: string }).error;
    if (err && err.includes("must be in")) return "error_invalid_policy";
  }
  return "error_fetch";
}
